
<mat-form-field style="width: 100%;" appearance="fill">
  <mat-label style="font-size: smaller;">Enter company domain (url)...(one domain per line)   Max 1000
  </mat-label>
  <textarea matInput rows="9" [formControl]="webSitesControl">
  </textarea>
</mat-form-field>

